import React from 'react';
import { planesParaElegir } from '../lib/planesParaElegir';

// LAS OPCIONES DE UN DESPLEGABLE DE PLAN DEL EQUIPO (Francisco, 12-10: los planes antiguos
// son solo para quien ya los tiene). Va dentro de un <select>: los planes nuevos y, si el
// de esa persona es antiguo, el suyo, para que guardar no se lo quite. A otro antiguo no se
// le pasa. La lista la decide el servidor (lib/planesParaElegir).
const OpcionesDePlan = ({ catalogo, planActual }) => {
    const { nuevos, suyo } = planesParaElegir(catalogo, planActual);
    return (
        <>
            {suyo && (
                <optgroup label="Su plan actual">
                    <option value={suyo.code}>{suyo.name}</option>
                </optgroup>
            )}
            <optgroup label="Planes nuevos">
                {nuevos.map(p => <option key={p.code} value={p.code}>{p.name}</option>)}
            </optgroup>
        </>
    );
};

export default OpcionesDePlan;
